import axios from "../utils/request";
import qs from "qs";

let userInfo={
    serviceStatistics:()=>{                      //服务统计
        return axios({
            method: "get",
            url: "/admin/v1/serviceStatistics",
        })
    },
    customerInfoStatistics:()=>{                        //服务对象信息统计
        return axios({
            method: "get",
            url: "/admin/v1/customerInfoStatistics",
        })
    },
    customerServiceStatistics:(data)=>{                        //服务对象服务统计
        return axios({
            method: "get",
            url: "/admin/v1/customerServiceStatistics",
			params: data
        })
    },
	serviceProjectStatistics:(data)=>{
	    return axios({
	        method: "get",
	        url: "/admin/v1/serviceProjectStatistics",
			params: data
	    })
	},
	serviceCommentStatistics:()=>{
	    return axios({
	        method: "get",
	        url: "/admin/v1/serviceCommentStatistics"
	    })
	},
}
export default userInfo;